import moment from 'moment-timezone'

export const businessHours = {
  'monday'     : ['08:00-17:00'],
  'tuesday'    : ['08:00-17:00'],
  'wednesday'  : ['08:00-17:00'],
  'thursday'   : ['08:00-17:00'],
  'friday'     : ['08:00-17:00'],
  'saturday'   : [],
  'sunday'     : [],
  'exceptions' : {
      '01-01'      : [], // TODO: Support opening hours on exceptions
      '12-24'      : [],
      '12-25'      : [],
      '12-31'      : [],
  },
};

/**
 * Specify the start and end date to retrieve the amount of time that the business is open.
 * @param {Date | string} startDate 
 * @param {Date | string} endDate 
 * @param {string} timezone 
 * @returns 
 */
const useOpeningHoursDiff = (startDate, endDate, timezone) => {
  let start = moment(startDate);
  let end = moment(endDate);

  if (timezone) {
    start = start.tz(timezone);
    end = end.tz(timezone);
  }

  // If the start date is after the end date, swap them
  if (start.isAfter(end)) {
    const temp = start;
    start = end;
    end = temp;
  }
  
  const datePointer = start;
  let secondCounter = 0;

  const incrementWhile = () => {
    datePointer.add(1, 'days').startOf('day');
  }

  while (datePointer.isBefore(end)) {
    // Check if date is an exception
    if (businessHours.exceptions[datePointer.format('MM-DD')]) {
      incrementWhile();
      continue;
    }

    // Check if date is not a business day
    if (!businessHours[datePointer.format('dddd').toLowerCase()].length > 0) {
      incrementWhile();
      continue;
    }

    // Check if date falls within business hours
    const businessHoursForDay = businessHours[datePointer.format('dddd').toLowerCase()];
    for (let i = 0; i < businessHoursForDay.length; i++) {
      const businessHoursForDayStart = moment(datePointer.format('YYYY-MM-DD') + ' ' + businessHoursForDay[i].split('-')[0]);
      const businessHoursForDayEnd = moment(datePointer.format('YYYY-MM-DD') + ' ' + businessHoursForDay[i].split('-')[1]);
      if (datePointer.isBetween(businessHoursForDayStart, businessHoursForDayEnd, undefined, '[]')) {
        
        // check if the end date is within the same business hour
        if (end.isBefore(businessHoursForDayEnd)) {
          secondCounter += end.diff(datePointer, 'seconds');
        }

        // check if the end date is after the business hour
        if (end.isSameOrAfter(businessHoursForDayEnd)) {
          secondCounter += businessHoursForDayEnd.diff(datePointer, 'seconds');
        }

      }

      // check if the start date is before the business hour
      if (datePointer.isBefore(businessHoursForDayStart)) {
        // check if end date is within the business hour
        if (end.isBetween(businessHoursForDayStart, businessHoursForDayEnd, undefined, '[]')) {
          secondCounter += end.diff(businessHoursForDayStart, 'seconds');
        }

        // if end date is after the business hour
        if (end.isAfter(businessHoursForDayEnd)) {
          secondCounter += businessHoursForDayEnd.diff(businessHoursForDayStart, 'seconds');
        }
      }
    }

    incrementWhile();
  }

  return {
    days: secondCounter / 86400,
    hours: secondCounter / 3600 % 24,
    minutes: secondCounter / 60 % 60,
    seconds: secondCounter % 60,
  }
};

export default useOpeningHoursDiff;
